export default "__VITE_ASSET__DyNrPyBs__"